<template>
  <div class="chart-legend">
    <div v-for="serie in dataset" :key="serie.name" class="chart-legend-item">
      <div class="serie">
        <div class="color-box" :style="{ backgroundColor: serie.color }"></div>

        <div class="serie-name">{{ serie.name }}</div>
      </div>
      <v-spacer></v-spacer>

      <div class="values">
        <div class="count-wrapper">
          <div class="count">
            {{ serie.value | number }} ({{ formatDecimals(serie.percentage) }}%)
          </div>
        </div>
        <v-tooltip top max-width="400px">
          <template v-slot:activator="{ on }">
            <div v-on="on" class="increase">
              <IncreaseIndicator
                :value="serie.increase"
                :no-background="true"
              />
            </div>
          </template>
          <span>
            {{ $t("message.dashboard.widgetTooltip.comparedToLast30Days") }}
          </span>
        </v-tooltip>
      </div>
    </div>
  </div>
</template>

<script>
import IncreaseIndicator from "@/components/Dashboard/base/IncreaseIndicator";

export default {
  name: "DashboardChartLegend",
  components: {
    IncreaseIndicator
  },
  props: {
    dataset: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    formatDecimals(value) {
      return value.toFixed(1) * 1;
    }
  }
};
</script>

<style lang="scss" scoped>
.chart-legend {
  width: 100%;
  margin-top: auto;
  margin-bottom: auto;
}

.chart-legend-item {
  margin-top: $spacing * 2;
  margin-bottom: $spacing * 2;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  white-space: nowrap;
}

.serie {
  display: flex;
  flex-direction: row;
  flex: 1;
}

.serie-name {
  flex: 1;
}

.values {
  display: flex;
  flex-direction: row;
  flex-basis: 180px;
  flex-grow: 0;
  flex-shrink: 1;
  margin-left: auto;
}

.color-box {
  width: 4px;
  height: 19px;
  border-radius: 3px;
  margin-right: $spacing * 2.5;
}

.count-wrapper {
  display: flex;
  flex: 1;
  margin-left: $spacing;
  margin-right: $spacing;
}

.increase {
  display: flex;
  flex: 1;
  justify-content: flex-end;
}

.count {
  @include font-size(14px);
  font-weight: normal;
  line-height: 17px;
  color: $text;
  opacity: 0.5;
}
</style>
